<template>
  <NuxtLayout>
    <HeroHeader class="placeList__HeroHeader" :image="page.image" :title-visible="false" stacked-elements>
      <h1 v-text="page.title" />
      <p v-text="page.description" />
    </HeroHeader>
    
    <CMSField v-if="page?.content" :data="page.content" />
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'aminess'
  });
  
  defineProps({
    page: {}
  });

  useHead({
    htmlAttrs: {
      class: 'fixedHeader fixedHeader--WithoutTopPadding',
    },
  })
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_placeList.scss');
</style>